/**
 * Mega Menu - Panel Centre Theme
 * Desktop: hover/focus mega dropdowns
 * Mobile: slide-out drawer with accordions
 */
(function () {
  'use strict';

  /* ---- Constants ---- */
  const HOVER_DELAY = 120;       // ms before closing on mouseleave
  const BREAKPOINT = 990;

  /* ---- Desktop Mega Menu ---- */
  function initDesktopMega() {
    const items = document.querySelectorAll('.mega-nav__item[data-mega-dropdown]');
    let closeTimer = null;

    items.forEach(function (item) {
      const link = item.querySelector('.mega-nav__link');
      const dropdown = item.querySelector('.mega-dropdown');
      if (!dropdown) return;

      // Hover open
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeAllDesktop();
        openDesktopItem(item);
      });

      // Hover close with delay
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          closeDesktopItem(item);
        }, HOVER_DELAY);
      });

      // Click/tap: on touch devices toggle dropdown, on desktop with mouse allow navigation
      link.addEventListener('click', function (e) {
        if (window.innerWidth >= BREAKPOINT && dropdown) {
          // If dropdown is already open (opened via hover), let the click navigate
          if (item.classList.contains('is-active')) {
            // Allow navigation — don't prevent default
            return;
          }
          // If dropdown is closed (touch device or keyboard), open it first
          if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
            e.preventDefault();
            closeAllDesktop();
            openDesktopItem(item);
          }
          // On mouse devices, hover already opened it, so click navigates
        }
      });

      // Keyboard: Enter/Space toggles, Escape closes
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('is-active')) {
            closeDesktopItem(item);
            link.focus();
          } else {
            closeAllDesktop();
            openDesktopItem(item);
            // Focus first link in dropdown
            var first = dropdown.querySelector('a');
            if (first) first.focus();
          }
        }
        if (e.key === 'Escape') {
          closeDesktopItem(item);
          link.focus();
        }
      });

      // Keyboard: Escape from within dropdown
      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDesktopItem(item);
          link.focus();
        }
      });
    });

    // Close on click outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mega-nav__item[data-mega-dropdown]')) {
        closeAllDesktop();
      }
    });
  }

  function openDesktopItem(item) {
    item.classList.add('is-active');
    var link = item.querySelector('.mega-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  function closeDesktopItem(item) {
    item.classList.remove('is-active');
    var link = item.querySelector('.mega-nav__link');
    if (link) link.setAttribute('aria-expanded', 'false');
  }

  function closeAllDesktop() {
    document.querySelectorAll('.mega-nav__item.is-active').forEach(function (item) {
      closeDesktopItem(item);
    });
  }

  /* ---- Mobile Mega Menu ---- */
  function initMobileMega() {
    var nav = document.getElementById('mobile-mega-nav');
    if (!nav) return;

    var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    var closeBtn = nav.querySelector('.mobile-mega-nav__close');
    var overlay = nav.querySelector('.mobile-mega-nav__overlay');
    var triggers = nav.querySelectorAll('.mobile-mega-nav__trigger');

    function openMobile() {
      nav.classList.add('is-open');
      document.body.classList.add('mega-nav-open');
      // Trap focus
      trapFocus(nav.querySelector('.mobile-mega-nav__drawer'));
      // Focus close button
      if (closeBtn) closeBtn.focus();
    }

    function closeMobile() {
      nav.classList.remove('is-open');
      document.body.classList.remove('mega-nav-open');
      if (toggleBtn) toggleBtn.focus();
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        if (nav.classList.contains('is-open')) {
          closeMobile();
        } else {
          openMobile();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeMobile);
    if (overlay) overlay.addEventListener('click', closeMobile);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMobile();
      }
    });

    // Accordion toggles
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var parent = trigger.closest('.mobile-mega-nav__item');
        var isOpen = parent.classList.contains('is-open');
        var panel = parent.querySelector('.mobile-mega-nav__panel');

        // Close all other panels
        nav.querySelectorAll('.mobile-mega-nav__item.is-open').forEach(function (openItem) {
          if (openItem !== parent) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.mobile-mega-nav__trigger').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle this panel
        if (isOpen) {
          parent.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          parent.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          // Scroll into view if needed
          setTimeout(function () {
            parent.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 300);
        }
      });
    });
  }

  /* ---- Trap focus helper (reuse global if available) ---- */
  function trapFocus(container) {
    if (!container) return;
    if (typeof window.trapFocus === 'function') {
      window.trapFocus(container);
      return;
    }
    var focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          last.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }

  /* ---- Init ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDesktopMega();
      initMobileMega();
    });
  } else {
    initDesktopMega();
    initMobileMega();
  }
})();
